import { AssetsProps } from "../types";
import IdentificationIcon from "../../assets/header/identification.svg?react";
import OverviewIcon from "../../assets/header/overview.svg?react";
import AffiliateIcon from "../../assets/header/affiliate.svg?react";
import ApiIcon from "../../assets/header/api-line.svg?react";
import FeesIcon from "../../assets/header/fees.svg?react";
import CouponIcon from "../../assets/header/nav/coupon.svg?react";
import LogoutIcon from "../../assets/header/log-out.svg?react";
import CopyIcon from "../../assets/header/copy.svg?react";
// import SubAccountIcon from "../../assets/header/sub-account.svg?react";
import { useStoreState } from "../store/useStore";
import { stylesBg, stylesBorder, stylesUid, stylesVip } from "./styles";
import { stylesHover, dropDownStylesText } from "../styles";
import useCopyToClipboard from "../hooks/useCopyToClipboard";
import { useToast } from "@blofin/blofin-ui";
import { useTranslations } from "use-intl";
import useLogout from "../hooks/useLogout";
import { useEffect, useMemo, useState } from "react";
import { cloneDeep } from "lodash";
import SwitchDialog from "./switchDialog";
import useAction from "../hooks/useAction";
import { SubAccountResponse } from "./type";
import Cookies from "js-cookie";
import styles from "./index.module.scss";
import Hot from "../Hot";

const assets: AssetsProps[] = [
  {
    label: "accountAndSecurity",
    link: "account/overview",
    icon: OverviewIcon,
    key: 0
  },
  {
    label: "identification",
    link: "account/identification",
    icon: IdentificationIcon,
    key: 1
  },
  {
    label: "coupons",
    link: "account/coupons",
    icon: CouponIcon,
    key: 2
  },
  {
    label: "affiliate",
    link: "affiliates",
    icon: AffiliateIcon,
    key: 3
  },
  {
    label: "myTradingFees",
    link: "account/trading-fees",
    icon: FeesIcon,
    key: 4
  },
  {
    label: "api",
    link: "account/apis",
    icon: ApiIcon,
    key: 5,
    isSupportDemoTrading: true,
    isSupportSubAccount: true
  }
  // {
  //   label: "subAccount",
  //   link: "account/sub-account",
  //   icon: SubAccountIcon,
  //   key: 6,
  //   isShowInUserGray: true,
  //   hot: true
  // },
];

const OverviewPopper = () => {
  const { userInfo, localeLink, isDemoTrading } = useStoreState();

  const copy = useCopyToClipboard();

  const { methods } = useToast();

  const t = useTranslations("header");

  const { logout } = useLogout();

  const [isUserInGray, setIsUserInGray] = useState(false);

  const [switchDialogOpen, setSwitchDialogOpen] = useState(false);

  const { getSubAccountLists, getUserGray } = useAction();

  const [subAccountInfo, setSubAccountInfo] = useState<SubAccountResponse | null>(null);

  const copyUid = async () => {
    const res = await copy(userInfo?.uid as string);
    if (res.type === "success") {
      methods.success("success");
    } else {
      methods.danger("error");
    }
  };

  const menus = useMemo(() => {
    let nav = cloneDeep(assets);

    if (isDemoTrading) {
      nav = nav.filter((item) => item.isSupportDemoTrading);
    }

    if (userInfo?.account_type === "NORMAL_SUB_ACCOUNT") {
      nav = nav.filter((item) => item.isSupportSubAccount);
    }

    if (!isUserInGray) {
      nav = nav.filter((item) => !item.isShowInUserGray);
    }

    return nav;
  }, [isDemoTrading, userInfo?.account_type, isUserInGray]);

  // const isSubAccount = useMemo(() => {
  //   return userInfo?.account_type === "NORMAL_SUB_ACCOUNT";
  // }, [userInfo]);

  const getSubAccount = async () => {
    try {
      if (Cookies.get("Global-UserViewType") === "demo-trading") {
        return;
      }
      getSubAccountLists()
        .then((res) => {
          const response = res as unknown as { code: number; data: SubAccountResponse };
          if (response.code === 200) {
            setSubAccountInfo(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (Cookies.get("Global-UserViewType") !== "demo-trading") {
      getSubAccount();
    }
  }, []);

  const getUserGrayState = async () => {
    try {
      getUserGray({ type: 2 }).then((res) => {
        const response = res as unknown as { code: number; data: { gray_flg: boolean } };
        if (response.code === 200) {
          setIsUserInGray(!!response.data.gray_flg);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (Cookies.get("Global-UserViewType") !== "demo-trading") {
      if (userInfo?.account_type === "MAIN") {
        getUserGrayState();
      } else {
        setIsUserInGray(true);
      }
    }
  }, [userInfo?.account_type]);

  return (
    <div
      className={`h-[64px] relative group flex items-center ${styles["user-overview-container"]}`}
      onMouseEnter={getSubAccount}
    >
      <div className="relative">
        {/* {!isSubAccount && !isDemoTrading && (
          <Hot
            theme="light"
            text="New"
            className="w-[26px] !h-[16px] absolute right-[-13px] top-[-2px]"
            fontSize="text-[20px] scale-50"
            fontStyle="normal"
            fontClassName="font-[500]"
          />
        )} */}

        <img
          className="w-[32px] h-[32px] cursor-pointer rounded-full"
          src={userInfo?.profile || ""}
        />
      </div>
      <div
        className={`${stylesBg({
          mode: "light"
        })} shadow-[0_2px_20px_rgba(0,0,0,.12)] ${styles["user-overview-hover-animate"]}`}
      >
        <div className="flex justify-between flex-col">
          <div className={`flex justify-between px-[16px] pb-[10px]`}>
            <img
              className="w-[40px] h-[40px] mr-[12px] rounded-full"
              src={userInfo?.profile}
              alt=""
            />
            <div
              className={`pb-[4px] font-semibold mr-[12px] ${dropDownStylesText({
                mode: "light"
              })}`}
            >
              <p className="whitespace-nowrap overflow-hidden text-ellipsis text-[14px] w-[126px]">
                {userInfo?.nick_name}
              </p>
              <p
                className={stylesUid({
                  mode: "light"
                })}
                onClick={copyUid}
              >
                <span className="whitespace-nowrap overflow-hidden text-ellipsis text-[14px] w-[106px]">
                  UID: {userInfo?.uid}
                </span>
                <CopyIcon className="w-[16px] h-[16px] ml-[6px] cursor-pointer" />
              </p>
            </div>
            <div
              className={stylesVip({
                mode: "light"
              })}
            >
              {userInfo?.vip_level === -1 ? t("special") : `VIP${userInfo?.vip_level || 0}`}
            </div>
          </div>
          {/* {subAccountInfo?.sub_account_list &&
            subAccountInfo.sub_account_list.length > 0 &&
            isUserInGray && (
              <div className="w-full px-[10px] py-[2px]">
                <Button
                  size="small"
                  theme="light"
                  variant="ghost2"
                  className="w-full"
                  onClick={() => setSwitchDialogOpen(true)}
                >
                  {t("swichAccount")}
                </Button>
              </div>
            )} */}
          {menus.map((item, index) => {
            if (item.label === "api") {
              return (
                <a
                  key={index}
                  href={`${localeLink}/${item.link}`}
                  className={`h-[48px] px-[24px] ${stylesHover({
                    mode: "light"
                  })} ${dropDownStylesText({
                    mode: "light"
                  })}`}
                >
                  <item.icon className="w-[24px] h-[24px] mr-[10px]" />
                  {t(item.label)}
                  {item.hot && <Hot theme="light" text="New" />}
                </a>
              );
            } else {
              return (
                <a
                  key={index}
                  href={`${localeLink}/${item.link}`}
                  className={`h-[48px] px-[24px] ${stylesHover({
                    mode: "light"
                  })} ${dropDownStylesText({
                    mode: "light"
                  })}`}
                >
                  <item.icon className="w-[20px] h-[20px] mr-[10px]" />
                  {t(item.label)}
                  {item.hot && (
                    <Hot
                      theme="light"
                      className="w-[26px] !h-[16px] ml-[2px] letter-spacing-[-0.2px]"
                      text="New"
                      fontSize="text-[20px] scale-50"
                      fontStyle="normal"
                      fontClassName="font-[500]"
                    />
                  )}
                </a>
              );
            }
          })}
          <div
            className={`h-[48px] px-[24px] ${stylesHover({
              mode: "light"
            })} ${dropDownStylesText({
              mode: "light"
            })} border-t ${stylesBorder({
              mode: "light"
            })}`}
            onClick={logout}
          >
            <LogoutIcon className="w-[20px] h-[20px] mr-[10px]" />
            {t("logout")}
          </div>
        </div>
      </div>

      <SwitchDialog
        open={switchDialogOpen}
        onClose={() => setSwitchDialogOpen(false)}
        subAccountInfo={subAccountInfo}
      />
    </div>
  );
};

export default OverviewPopper;
